import * as React from 'react';

import { CombinedPackageViewProps } from '../../components/list/package';
import ListPerformances from '../../components/list/performances';

const ListPackageView: React.StatelessComponent<CombinedPackageViewProps> = props => {

    const selectSubscriptionButton = (
        <button className={`${props.selectedPackage && props.useUnseatedReserve ? "btn-secondary" : "btn-primary"}`} onClick={(e) => {
            if (props.selectedPackage && props.useUnseatedReserve) {
                props.removeFromCart(props.package.id)
            }
            else {
                (e.target as HTMLElement).classList.add('btn-loading');
                (e.target as HTMLButtonElement).disabled = true;
                props.selectPackage(props.package, props.useUnseatedReserve);
            }
        }}>
            {props.selectedPackage && props.useUnseatedReserve ? props.text.removeButtonText : props.text.selectSubscriptionButtonText}
        </button>
    );

    return (
        <li key={props.package.id} data-package-id={props.package.id} className="ace-subs-item">
            <div className="ace-subs-item-inner">
                {
                    props.package.packageImageUrl != "" ? 
                        <div>
                            <img src={props.package.packageImageUrl} alt={props.package.title} />
                        </div>
                    : null
                }
                <div className="ace-subs-item-info">
                    <div className="ace-subs-item-top">
                        <h2 className="h3-style" dangerouslySetInnerHTML={{ __html: props.package.title }}></h2>
                        {selectSubscriptionButton}
                    </div>
                    <div className="stack-sm">
                        {
                            props.packagePerformances && props.packagePerformances.length > 0 ?
                                <p className="bold">
                                    {props.packagePerformances.length} performances
                                </p>
                                : null
                        }
                        {
                            props.package.description ?
                                <p>
                                    {props.package.description}
                                </p>
                                : null
                        }
                        <div className="rich-text stack-xs">
                            {
                                props.package.packageTimeDescriptionMessage ?
                                    <p className="bold">{props.package.packageTimeDescriptionMessage}</p>
                                    : null
                            }
                        </div>
                    </div>
                </div>
            </div>
            <div className="accordion-list space-top-lg">
                <div className="accordion-list-item ace-subs-accordion-item">
                    <button className="accordion-trigger" aria-expanded={`${props.showPerformances ? 'true' : 'false'}`}
                        onClick={props.toggleShowPerformances}>
                        {
                            props.showPerformances ? props.text.hidePerformancesButtonText
                                : props.text.viewPerformancesButtonText
                        }
                    </button>
                </div>
            </div>

            <div className="accordion-panel" aria-hidden={!props.showPerformances}>
                <div className="accordion-panel-content">
                    <ListPerformances filteredPerformances={props.packagePerformances} />
                </div>
            </div>
        </li>
    )
}

export default ListPackageView;